import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { isDeepLinkProcessing } from "utils/deepLinkUtils";

// Helper to detect if we're in local development environment
const isLocalDevelopment = () => {
  if (typeof globalThis.window === 'undefined') return false;

  const hostname = globalThis.window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isNamedDevelopmentHost = hostname === 'anuj.dev.sofmen.com';
  const isPrivateLanHost =
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);

  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';

  // In local development, skip redirects to allow testing without token
  return (isLocalhost || isNamedDevelopmentHost || isPrivateLanHost) && isDevelopment;
};

// Helper to treat refactor deployments like local development
const isRefactorEnvironment = () => process.env.REACT_APP_ENV === 'refactor';

const Private = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const isRootPath = location.pathname === "/";
  const isDeepLink = isDeepLinkProcessing();
  const isLocalDev = isLocalDevelopment() || isRefactorEnvironment();

  // Clear deep link processing flag when user reaches /add_store page
  useEffect(() => {
    if (location.pathname === "/add_store" && isDeepLink) {
      localStorage.removeItem('deep_link_processing');
    }
  }, [location.pathname, isDeepLink]);

  // Redirect to marketing URL if no token is present (skip during local development)
  useEffect(() => {
    if (!token && typeof globalThis.window !== 'undefined' && !isLocalDev) {
      const marketingUrl = process.env.REACT_APP_BASE_URL_MARKETING || '/';
      globalThis.window.location.href = marketingUrl;
    }
  }, [token, isLocalDev]);

  if (token && isRootPath) {
    return <Navigate to="/stores" />;
  }

  // If user is authenticated and has deep link processing flag, redirect to /add_store
  if (token && isDeepLink && location.pathname !== "/add_store") {
    return <Navigate to="/add_store" />;
  }

  if (!token && isLocalDev) {
    return <Outlet />;
  }

  // If no token, show nothing while redirecting (the useEffect will handle the redirect)
  if (!token) {
    return null;
  }

  return <Outlet />;
};

export default Private;
